import React from 'react';

import ElementWithIntersectionObserver
	from '@app/components/UI/components/ElementWithIntersectionObserver/ElementWithIntersectionObserver';

interface Article {
	title: string;
	text: string;
	subtitle: string;
}

interface Props {
	articles: Article[];
}

const Article: React.FC<Article> = ({title, text, subtitle}) => {
	const ref = React.useRef<HTMLDivElement>(null);
	const handleScroll = () => {
		if (ref.current) {
			const {top, height} = ref.current.getBoundingClientRect();
			const center = top + height / 2;
			let opacity = 1  - 2 * Math.abs(center - window.innerHeight / 2) / window.innerHeight;

			if (opacity < 0.05) opacity = 0.05;
			ref.current.style.opacity = `${opacity}`;
		}
	};

	return <ElementWithIntersectionObserver
		onScroll={handleScroll}
		inner={show =>
			<div className={`article ${show ? 'show-article' : ''}`}>
				<div ref={ref}>
					<div className="perspective-2 title">
						<h2 className="article__title">
							{title}
						</h2>
					</div>
					<div className="article__content">
						<div className="perspective-2">
							<h3 className="article__subtitle">
								{subtitle}
							</h3>
						</div>
						<p className="article__text">
							{text}
						</p>
					</div>
				</div>
			</div>
	}/>;
};

const Articles: React.FC<Props> = ({articles}) => {
	return <>
		{articles.map((item, i) => <Article key={i} {...item}/>)}
	</>;
};

export default Articles;
